// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/kevindavis/Projects/kevindavi5dotcom/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/kevindavis/Projects/kevindavi5dotcom/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("/Users/kevindavis/Projects/kevindavi5dotcom/src/pages/projects.js" /* webpackChunkName: "component---src-pages-projects-js" */)
}

